export enum SelectorTypes {
  Vertical = 'vertical',
  Role = 'role',
}
